import React, { createContext, useContext, useMemo, useState } from 'react';

interface DemoContextValue {
  isDemo: boolean;
  setDemo: (next: boolean) => void;
}

const DemoContext = createContext<DemoContextValue>({ isDemo: false, setDemo: () => {} });

export const DemoProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isDemo, setIsDemo] = useState<boolean>(false);
  const value = useMemo(() => ({ isDemo, setDemo: setIsDemo }), [isDemo]);
  return <DemoContext.Provider value={value}>{children}</DemoContext.Provider>;
};

export const useDemo = () => useContext(DemoContext);
